import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  padding: (p) => p.spacing(2, 1.5),
  overflow: 'auto',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};
